import React, { useState, useEffect } from "react";
import Wrapper from "../Components/Wrapper";
import Herosection from "../Components/Herosection";
import { Col, Container, Pagination, Row, Table } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import programNames from "../assets/API/programsName";

function AllPrograms() {
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationItems, setPaginationItems] = useState([]);
  const itemsPerPage = 5;
  const { slug } = useParams();

  const selectedData = programNames.find((item) => item.slug === slug);
  const totalPages = Math.ceil(selectedData?.data?.length / itemsPerPage);

  useEffect(() => {
    const items = [];
    for (let number = 1; number <= totalPages; number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === currentPage}
          onClick={() => paginationHandler(number)}
        >
          {number}
        </Pagination.Item>
      );
    }
    setPaginationItems(items);
  }, [totalPages, currentPage]);

  function paginationHandler(page) {
    setCurrentPage(page);
  }

  const displayData = selectedData?.data?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <Wrapper id={"programSectionWrapper"}>
      <Herosection title={"Programs"} />

      <Container>
        <div className="programSection">
          <div className="tableWrapper py-md-5 py-3">
            <Row className="justify-content-center">
              <Col lg={6} md={8} sm={10} data-aos="zoom-in">
                <Table responsive bordered striped>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayData?.map((item, index) => (
                      <tr key={item.id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td className="text-start">{item.name}</td>
                        <td>
                          <Link to={`/programe-description/${item?.slug}`}>
                            <i className="fa-solid fa-eye"></i>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>
          <div className="pagination_wrapper">
            <Pagination className="justify-content-center">
              {paginationItems}
            </Pagination>
          </div>
        </div>
      </Container>
    </Wrapper>
  );
}

export default AllPrograms;
